import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-archived',
  templateUrl: './icon-archived.component.html',
  styleUrls: ['./icon-archived.component.scss']
})
export class IconArchivedComponent implements OnInit {
  @Input() color: string = '#262628';
  @Input() size: number = 18;
  @Input() hoverColor: string = null;
  mainColor: string;

  constructor() { }

  ngOnInit() {
    this.mainColor = this.color;
  }

  onHover() {
    if (this.hoverColor) {
      this.mainColor = this.hoverColor;
    }
  }

  onLeave() {
    this.mainColor = this.color;
  }

}
